/* unplugin-vue-components disabled */import { render } from "./statement_account.vue?vue&type=template&id=90737bae&scoped=true"
import script from "./statement_account.vue?vue&type=script&lang=js"
export * from "./statement_account.vue?vue&type=script&lang=js"

import "./statement_account.vue?vue&type=style&index=0&id=90737bae&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90737bae"]])

export default __exports__